import { createContext } from 'react';

export const CHECKOUT_FLOW = 'checkout';
export const VERIFY_FLOW = 'verify';
export const TIER_1_FLOW = 'tier1';

export const KYCContext = createContext({
  flow: VERIFY_FLOW,
});
